import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import useQueryRequestParams from '../../../../hooks/useQueryRequestParams';
import envVars from '../../../../constants/envVars';
const useDeviceLogSubscribe = () => {
    const params = useQueryRequestParams();
    return useMutation({
        mutationFn: (attributes) => axios.post(`${envVars.API_CLOUD_HOSTNAME}backoffice/real-time-log/?serial=${attributes.serial}`, attributes, params),
        onSuccess: () => { }
    });
};
export default useDeviceLogSubscribe;
